"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts a Firestore timestamp to a
 * javascript Date object. If a Date object
 * is passed in, it is returned unchanged.
 *
 * @param timestamp    Firestore timestamp or Date.
 * @param defaultValue Returned if timestamp is not a valid date.
 */
function toDate(timestamp, defaultValue) {
    if (defaultValue === void 0) { defaultValue = new Date(); }
    if (timestamp) {
        var ts = timestamp;
        if (typeof ts.toDate === 'function') {
            return ts.toDate();
        }
        if (timestamp instanceof Date) {
            return timestamp;
        }
    }
    return defaultValue;
}
exports.default = toDate;
//# sourceMappingURL=toDate.js.map